

































































import {Vue, Component} from 'vue-property-decorator';
import ReviewInfo from '@/components/product/review/ReviewInfo.vue';

import {addClass, removeClass} from '@/utils/classUtils';
import {ncpPopup, popupResize} from '@/utils/ncp';

@Component({
  components: {ReviewInfo}
})
export default class ReportDetail extends Vue {
  private initOver = false;
  private reviewInfo: any = {
    reviewDetail: {},
    reason: ''
  };
  private reportDetail: any = {};

  // 신고자
  private openMemberPop() {
    ncpPopup(`/member/popup/crm/${this.reportDetail.register.memberNo}`, window.$t('PRODUCT_REVIEW_POP_CRM'), 1100, 980);
  }

  // 저장
  private async save() {
    // 전시상태
    let request = {
      pathParams: {
        reviewNo: this.reportDetail.reviewNo
      },
      data: {
        reason: this.reviewInfo.reason,
        displayStatusType: this.reviewInfo.reviewDetail.displayStatusType
      }
    };
    await this.$api.putReviewsReviewNoStatus(request);

    let pageFrom = sessionStorage.getItem('reportDetailFrom');
    alert(this.$t('PRODUCT_REVIEW_SAVE_MSG'));
    if (pageFrom === 'ReportList') {
      $(window.opener.location).attr('href', 'javascript:window.detailCallBack();');
    }
    window.close();
  }

  // 취소
  private close() {
    window.close();
  }

  private async mounted() {
    addClass(document.body, 'popup_large');
    let reportRequest: any = {
      pathParams: {
        reviewNo: this.$route.query.reviewNo,
        reportNo: this.$route.params.reportNo
      }
    };
    let reportResponse = await this.$api.getReviewsReviewNoReportsReportNo(reportRequest);
    this.reportDetail = reportResponse.data;

    let reviewRequest: any = {
      pathParams: {
        reviewNo: this.reportDetail.reviewNo
      }
    };
    let reviewResponse = await this.$api.getReviewsReviewNo(reviewRequest);
    this.reviewInfo.reviewDetail = reviewResponse.data;

    this.initOver = true;
    this.$nextTick(() => {
      popupResize();
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_large');
  }
}
